<template>
  <div class="footer">
    <div class="footer-top section-padding">
      <div class="container">
        <div class="row">
          <div class="col-sm-3">
            <div class="footer-widget">
              <h3>Sobre Nós</h3>
              <ul class="tr-list">
                <li>
                  <router-link  :to="{ name: 'About' }">
                    Sobre Nós
                  </router-link>
                </li>
                <li>
                  <router-link  :to="{ name: 'HowItsWorks' }">
                    Como funciona
                  </router-link>
                </li>
                <!-- <li><a href="termos.html">Termos e Condições</a></li> -->
                <!-- <li><a href="politica-rpivacidade.html">Política de Privacidade</a></li> -->
                <li>
                  <router-link :to="{ name: 'Contact'}">
                    Contato
                  </router-link>
                </li>
              </ul>
            </div>
          </div>
          <div class="col-sm-3">
            <div class="footer-widget">
              <h3>Empresas</h3>
              <ul class="tr-list">
                <li>
                  <router-link :to="{ name: 'PostJobCompany'}">
                    Cadastrar Vagas
                  </router-link>
                </li>
                <!-- <li><a href="login-empresa.html">Minhas ContrataçÕes</a></li> -->
                <!-- <li><a href="login-empresa.html">Meus Pagamentos</a></li> -->
                <!-- <li><a href="faq-empresa.html">FAQ</a></li> -->
              </ul>
            </div>
          </div>
          <div class="col-sm-3" v-if="false">
            <div class="footer-widget">
              <h3>Profissionais</h3>
              <ul class="tr-list">
                <li><a href="Indicacoes.html">Solicitar Indicações</a></li>
                <li><a href="login-profissional.html">Indicar Profissionais</a></li>
                <li><a href="login-profissional.html">Meus Ganhos</a></li>
                <li><a href="faq-empresa.html">FAQ</a></li>
              </ul>
            </div>
          </div>
          <div class="col-sm-3" v-if="false">
            <div class="footer-widget">
              <h3>Newsletter</h3>
              <p>Fique por Dentro de Todas as Novidades da Indicoo</p>
              <form class="contact-form" method="post" action="#">
                <div class="form-group">
                  <input
                    type="email"
                    class="form-control"
                    required="required"
                    placeholder="Meu E-Mail Principal"
                  />
                </div>
                <div class="form-group">
                  <button type="submit" class="btn btn-primary">Cadastrar</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-bottom">
      <div class="container">
        <div class="copyright">
          <p>Copyright © 2021 <a href="http://www.indicoo.com.vc">Indicoo.com.vc</a> Todos os Direitos Reservados.</p>
        </div>
        <div class="footer-social pull-right" v-if="false">
          <ul class="tr-list">
            <li>
              <a href="#" title="Twitter"><i class="fa fa-twitter"></i></a>
            </li>
            <li>
              <a href="#" title="Instagram"><i class="fa fa-instagram"></i></a>
            </li>
            <li>
              <a href="#" title="Youtube"><i class="fa fa-youtube"></i></a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Footer',
};
</script>

<style></style>
